module.exports = __webpack_public_path__ + "static/media/adserver_section4.0eb2fc03.png";